

import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import config from "../../config/config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

export default function NewQualityCheck({ show, handleClose,onNewcheck }) {
  const [listLoading, setListLoading] = useState(false);
  const [productList, setProductList] = useState([]);
  const [formData, setFormData] = useState({
    checkType: null,   // react-select object {value,label}
    product: null,     // react-select object {value,label}
    qtyTest: "",
    testDate: "",
    notes: "",
  });
  const [errors, setErrors] = useState({});

  // Fetch product list
  const fetchProductList = async () => {
    const token = getAuthToken();
    if (!token) return;
    setListLoading(true);
    try {
      const res = await axios.get(`${config.API}/product/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProductList(res.data.products || []);
    } catch (err) {
      console.error("Error fetching product list:", err);
    } finally {
      setListLoading(false);
    }
  };

  useEffect(() => {
    fetchProductList();
  }, []);

  // Options for react-select
  const checkTypeOptions = [
    { value: "Degreaser report check", label: "Degreaser report check" },
    { value: "Grit blasting report ", label: "Grit blasting report" },
    { value: "Viscosity check", label: "Viscosity check" },
     { value: "Film thickness check", label: "Film thickness check" },
  ];

  const productOptions = productList.map((product) => ({
    value: product.id,
    label: product.name,
  }));

  // Unified handler for react-select and inputs
  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    setErrors((prev) => ({ ...prev, [field]: null }));
  };

  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) {
      toast.error("No authentication token found");
      return;
    }

    try {
      const payload = {
        check_type: formData.checkType?.value || null,
        product_id: formData.product?.value || null,
        quantity_to_be_tested: formData.qtyTest,
        test_date: formData.testDate,
        notes: formData.notes,
      };

      const res = await axios.post(
        `${config.API}/supervisor/upcommingqualitychecks`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success(res.data.message || "Quality check scheduled successfully");

      // Reset form
      setFormData({
        checkType: null,
        product: null,
        qtyTest: "",
        testDate: "",
        notes: "",
      });
      setErrors({});
      onNewcheck()
      handleClose();
    } catch (err) {
      if (err.response?.status === 422 && err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      } else {
        toast.error(err.response?.data?.message || "Something went wrong");
      }
      console.error("Error submitting data:", err.response?.data || err.message);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="md" centered className="font_family">
      <Modal.Body className="p-5">
        <h5 className="fw-bold mb-4">New Quality Check</h5>

        <Form>
          {/* Check Type */}
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">Select Check Type</Form.Label>
            <Select
              options={checkTypeOptions}
              value={formData.checkType}
              onChange={(option) => handleChange("checkType", option)}
              placeholder="Select Measure"
            />
            {errors.check_type && (
              <div className="text-danger">{errors.check_type}</div>
            )}
          </Form.Group>

          {/* Product */}
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">Select Product</Form.Label>
            <Select
              options={productOptions}
              value={formData.product}
              onChange={(option) => handleChange("product", option)}
              isLoading={listLoading}
              placeholder="Select Product"
            />
            {errors.product_id && (
              <div className="text-danger">{errors.product_id}</div>
            )}
          </Form.Group>

          {/* Test Date */}
          <Row className="mb-3">
            <Col md={4}>
              <Form.Label className="fw-semibold">Test Date</Form.Label>
            </Col>
            <Col md={6}>
              <Form.Control
                type="date"
                value={formData.testDate}
                onChange={(e) => handleChange("testDate", e.target.value)}
              />
              {errors.test_date && (
                <div className="text-danger">{errors.test_date}</div>
              )}
            </Col>
          </Row>

          {/* Quantity */}
          <Row className="mb-3">
            <Col md={4}>
              <Form.Label className="fw-semibold">Quantity To Be Tested</Form.Label>
            </Col>
            <Col md={6}>
              <Form.Control
                type="number"
                value={formData.qtyTest}
                onChange={(e) => handleChange("qtyTest", e.target.value)}
              />
              {errors.quantity_to_be_tested && (
                <div className="text-danger">{errors.quantity_to_be_tested.join(", ")}</div>
              )}
            </Col>
          </Row>

          {/* Notes */}
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={formData.notes}
              onChange={(e) => handleChange("notes", e.target.value)}
            />
            {errors.notes && (
              <div className="text-danger">{errors.notes.join(", ")}</div>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-end">
        <Button variant="dark" onClick={handleSubmit}>
          Submit
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
